/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminCreateSipDoorMy2NDirectorySyncTaskPathParameters } from 'api/actions/admin-create-sip-door-my-2nd-irectory-sync-task/admin-create-sip-door-my-2nd-irectory-sync-task-path-parameters';
import { AdminCreateSipDoorMy2NDirectorySyncTaskResponse } from 'api/actions/admin-create-sip-door-my-2nd-irectory-sync-task/admin-create-sip-door-my-2nd-irectory-sync-task-response';

type AdminCreateSipDoorMy2NDirectorySyncTaskQueryParameters = Record<string, any>;

/**
 * The path of the AdminCreateSipDoorMy2NDirectorySyncTask action.
 */
export const adminCreateSipDoorMy2NDirectorySyncTaskActionPath = new SweetPath<
  keyof AdminCreateSipDoorMy2NDirectorySyncTaskPathParameters
>('/admin/custom/sip-doors/{sipDoorId}/my2n-directory-sync-tasks', { path: '{param}' });

/**
 * Creates a contextualized AdminCreateSipDoorMy2NDirectorySyncTask actions.
 */
export default function createAdminCreateSipDoorMy2NDirectorySyncTaskAction(axios: AxiosInstance) {
  return function adminCreateSipDoorMy2NDirectorySyncTaskAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminCreateSipDoorMy2NDirectorySyncTaskPathParameters;
    query?: AdminCreateSipDoorMy2NDirectorySyncTaskQueryParameters;
  }) {
    const path = adminCreateSipDoorMy2NDirectorySyncTaskActionPath.insert(parameters);

    return axios.post<AdminCreateSipDoorMy2NDirectorySyncTaskResponse, AdminCreateSipDoorMy2NDirectorySyncTaskResponse>(
      path,
      { params: query, headers }
    );
  };
}
